import { UseStore } from '../../../../types/zustand'
import { useContextStore, useContextStoreApi } from '../../../../utils/zustand'
import { DraggableModalStoreContext } from '../contexts/StoreContext'
import { DraggableModalStore } from '../store/interface'

export const useDraggableModalStore: UseStore<
  DraggableModalStore
> = selector => {
  return useContextStore(DraggableModalStoreContext, selector)
}

export const useDraggableModalStoreApi = () => {
  return useContextStoreApi(DraggableModalStoreContext)
}
